import React from 'react';
import './ProhibitedIcon.css';
import { Prohibited } from '../../assets/icons';

interface ProhibitedIconProps {
  size?: number;
  className?: string;
}

const ProhibitedIcon: React.FC<ProhibitedIconProps> = ({ size = 64, className = '' }) => {
  return (
    <div className={`prohibited-icon ${className}`} style={{ width: size, height: size }}>
      <Prohibited className="prohibited-svg" />
    </div>
  );
};

export default ProhibitedIcon;
